import { render, staticRenderFns } from "./ThreadActions.vue?vue&type=template&id=1d0d31a5&scoped=true&"
import script from "./ThreadActions.vue?vue&type=script&lang=js&"
export * from "./ThreadActions.vue?vue&type=script&lang=js&"
import style0 from "./ThreadActions.vue?vue&type=style&index=0&id=1d0d31a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0d31a5",
  null
  
)

export default component.exports